import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import AppDetailsPage from './AppDetails';
import { APP_LISTING_KIND } from '@/lib/appTypes';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
    case 'nprofile':
      // AI agent should implement profile view here
      return <div>Profile placeholder</div>;

    case 'note':
      // AI agent should implement note view here
      return <div>Note placeholder</div>;

    case 'nevent':
      // AI agent should implement event view here
      return <div>Event placeholder</div>;

    case 'naddr':
      // Check if it's an app listing
      if (decoded.data.kind === APP_LISTING_KIND) {
        return <AppDetailsPage naddr={decoded.data} />;
      }
      // AI agent should implement other addressable event views here
      return <div>Addressable event placeholder</div>;

    default:
      return <NotFound />;
  }
} 